<script lang="ts">
  // "Day 71 of 120" as a ring.
  export let value: number
  export let total: number
  export let size = 300
  export let stroke = 26
  export let label = 'Day'

  $: r = (size - stroke) / 2
  $: circ = 2 * Math.PI * r
  $: pct = total > 0 ? Math.max(0, Math.min(1, value / total)) : 0
</script>

<div class="xr-progress-ring" style="width: {size}px; height: {size}px;">
  <svg width={size} height={size} viewBox="0 0 {size} {size}" aria-hidden="true">
    <circle cx={size / 2} cy={size / 2} {r} fill="none" stroke="currentColor" stroke-opacity="0.14" stroke-width={stroke} />
    <circle cx={size / 2} cy={size / 2} {r} fill="none" style="stroke: var(--accent)" stroke-width={stroke} stroke-linecap="round"
      stroke-dasharray="{circ * pct} {circ}" transform="rotate(-90 {size / 2} {size / 2})" />
  </svg>
  <div class="xr-center">
    <span class="xr-label" style="font-size: {size * 0.08}px;">{label}</span>
    <span class="xr-value" style="font-size: {size * 0.4}px;">{value}</span>
    <span class="xr-total" style="font-size: {size * 0.08}px;">of {total}</span>
  </div>
</div>

<style>
  .xr-progress-ring {
    position: relative;
    flex: none;
  }
  svg {
    display: block;
  }
  .xr-center {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .xr-label, .xr-total {
    font-size: 24px;
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: var(--muted);
  }
  .xr-value {
    font-family: var(--display);
    font-weight: 800;
    font-size: 120px;
    line-height: 0.95;
  }
</style>
